/* eslint-disable no-undef */
import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import { makeApi, URLS } from 'Utils/apiUtil';
import { userDetail } from 'Stores/userDetail';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import HubspotForm from 'react-hubspot-form';
import * as CONSTANTS from 'Utils/constants';
import { ReactComponent as CloseIcon } from '../../../assets/svg/close-material.svg';
import PopupBgLineIcon from '../../../assets/png/popupBgline.png';
import Top100SoftwareCompanies2020 from '../../../assets/png/rating_batch_icon/top100SoftwareCompanies2020.png';
import LeaderSmallCompanies2020 from '../../../assets/png/rating_batch_icon/leaderSmallCompanies2020.png';
import ChromeWebStoreReview from '../../../assets/png/rating_batch_icon/chromeWebStoreReview.png';
import LeaderEnterpriseFall2020 from '../../../assets/png/rating_batch_icon/leaderEnterpriseFall2020.png';
import { LoadingWrapper } from './loadingWrapper';

class PricingPopupState {
  @observable showPricingPopup = false;

  @observable formData = {};

  @action
  setShowPricingPopup = (
    popup = false,
    type,
    unlock = false,
    isHubspotForm = false,
  ) => {
    this.showPricingPopup = popup;
  };
}
const pricingPopupState = new PricingPopupState();

const PricingPopup = observer(props => {
  const [
    showFormSubmissionMessage,
    setShowFormSubmissionMessage,
  ] = React.useState(false);
  const [selfTrialApiLoading, setSelfTrialApiLoading] = React.useState(false);

  const closePricingPopup = () => {
    Utils.removeBusinessEmailFromUrl();
    pricingPopupState.setShowPricingPopup(false);
  };

  const submitTrialRequest = (postData = {}) => {
    const config = {
      url: URLS.verifyTrialRequest,
      method: 'POST',
      data: postData,
    };
    setSelfTrialApiLoading(true);
    makeApi(config)
      .then(response => {
        setSelfTrialApiLoading(false);

        let msgStr = '';
        const { data } = response;
        if (data === 200) {
          Utils.mixpanelTrack(
            CONSTANTS.MX_HEADER_EVENT.START_FREE_TRIAL_ACTIVATED,
            {},
          );
          Utils.redirectToLbHomePage();
        } else {
          if (data === 201) {
            msgStr = `Your request for a FREE trial is successfully placed. Please check <a href="mailto:${postData.email}" target="_blank">${postData.email}</a> to activate the trial.`;
            Utils.mixpanelTrack(
              CONSTANTS.MX_HEADER_EVENT.START_FREE_TRIAL_EMAIL_SENT,
              {},
            );
          } else if (data === 202) {
            msgStr =
              'Oops, looks like there is an existing active trial from your organization. Please write to <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a>.';
            Utils.mixpanelTrack(
              CONSTANTS.MX_HEADER_EVENT.START_FREE_TRIAL_SAME_DOMAIN_ERROR,
              {},
            );
          } else {
            msgStr = `Uh-oh! Something went wrong. We're trying to figure it out. Please try again.
                If the issue persists, please write to <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a>.`;
            Utils.mixpanelTrack(
              CONSTANTS.MX_HEADER_EVENT.START_FREE_TRIAL_UNKNOWN_ERROR,
              {},
            );
          }

          confirmationPopupState.setPopupValues({
            title: '',
            content: msgStr,
            actionBtnText: 'OK',
            callback: () => {},
            needCancelBtn: false,
          });
          confirmationPopupState.setShowPopup(true);

          closePricingPopup();
        }
      })
      .catch(error => {
        setSelfTrialApiLoading(false);
        console.log('submitTrialRequest error ', error);
      });
  };

  const hubspotSuccessCallback = (formData = []) => {
    setTimeout(() => {
      const postData = {};
      // eslint-disable-next-line array-callback-return
      formData.map(item => {
        const { name = null, value } = item;
        if (name && name !== 'hs_context') postData[name] = value;
      });
      setShowFormSubmissionMessage(true);
      submitTrialRequest(postData);
    }, 300);
  };

  const handleSubmissionCloseClick = () => {
    setShowFormSubmissionMessage(false);
    closePricingPopup();
  };

  const FormSubmissionMsg = () => {
    return (
      <>
        <div className="confirmation-popup common-popup trial-hubspot-success-popup">
          <div className="popup-wrap">
            <div
              className="popup-close"
              title="Click here to close"
              onClick={() => handleSubmissionCloseClick(e)}
            >
              <CloseIcon />
            </div>
            <div className="popup-content-wrap">
              <div className="loading-wrap">
                {selfTrialApiLoading && (
                  <LoadingWrapper show={selfTrialApiLoading} />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="common-popup-mask" onClick={() => {}} />
      </>
    );
  };

  const HSFormWrapper = () => {
    return (
      <div className="hubspot-form">
        <HubspotForm
          portalId={CONSTANTS.HUBSPOT_PORTAL_ID}
          formId={CONSTANTS.SELF_TRIAL_HUBSPOT_FORM_ID}
          inlineMessage="Thank you! Your trial request is successfully placed. This page will automatically redirect."
          onSubmit={formData => {
            setTimeout(() => {
              hubspotSuccessCallback(formData);
            }, 250);
          }}
          onReady={form => {
            console.log('Form ready!');
            setTimeout(() => {
              Utils.removeBusinessEmailFromUrl();
            }, 500);
          }}
          loading={
            <div className="loading-icon">
              <LoadingWrapper show />
            </div>
          }
        />
      </div>
    );
  };

  const FreeTrialPopup = () => {
    const [showLoader, setShowLoader] = React.useState(true);
    React.useEffect(() => {
      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
    }, []);
    return (
      <div className="pricingPopup common-popup pricingHubSpotForm startFreeTrialHSForm">
        <div
          className="pricing-popup-overlay"
          onClick={e => closePricingPopup()}
        />
        <div className="pricing-popup">
          {showLoader && (
            <div className="loader-parent-wrap">
              <LoadingWrapper show />
            </div>
          )}
          <img className="bg-line" src={PopupBgLineIcon} alt="Popup bg icon" />

          <span className="close-popup" onClick={e => closePricingPopup()}>
            <CloseIcon />
          </span>

          <div className="free-trial-wrapper">
            <div className="free-trial-info-wrapper">
              <div className="free-trial-title">It’s FREE!</div>
              <div className="seperator-with-text">
                <div className="seperator-line" />
                <div className="seperator-text">You get</div>
              </div>
              <div className="trial-info-wrap">
                <div className="info-item-wrap">
                  <span className="value">20</span>
                  <span className="label">Credits</span>
                </div>
                {/* <div className="info-item-wrap">
                  <span className="value">05</span>
                  <span className="label">Downloads</span>
                </div> */}
                <div className="info-item-wrap">
                  <span className="value">03</span>
                  <span className="label">Licences</span>
                </div>
              </div>
              <div className="seperator-with-text">
                <div className="seperator-line" />
              </div>
              <div className="info-list-desc">
                <div className="info-list-item">
                  <i className="material-icons active-list">check_circle</i>
                  <div className="info-text-desc">
                    No credit card required. Hassle-free tryout.
                  </div>
                </div>
                <div className="info-list-item">
                  <i className="material-icons active-list">check_circle</i>
                  <div className="info-text-desc">
                    All features unlocked! Easily evaluate if Adapt fits your
                    need.
                  </div>
                </div>
              </div>
              <div className="img-list-wrap">
                <img src={Top100SoftwareCompanies2020} alt="top100" />
                <img src={LeaderEnterpriseFall2020} alt="top100" />
                <img src={ChromeWebStoreReview} alt="top100" />
              </div>
            </div>
            <div className="hubspot-form-wrapper">
              <div className="form-title">Start your FREE trial</div>
              <HSFormWrapper />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return pricingPopupState.showPricingPopup ? (
    <>
      {showFormSubmissionMessage ? <FormSubmissionMsg /> : <FreeTrialPopup />}
    </>
  ) : (
    ''
  );
});

const PricingPayment = observer(props => {
  return <>{pricingPopupState.showPricingPopup && <PricingPopup />}</>;
});

export { PricingPayment, PricingPopup, pricingPopupState };
export default PricingPayment;
